import { useFormContext } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { STYLE_GUIDE_SECTIONS } from "@/components/modals/organizationSettings/constants";
import type { StyleGuideFormValues } from "@/components/modals/organizationSettings/types";

interface Props {
  onSubmit: (data: StyleGuideFormValues) => Promise<void>;
  onCancel: () => void;
  isUpdating: boolean;
}

export const StyleGuideTab = ({ onSubmit, onCancel, isUpdating }: Props) => {
  const { register, handleSubmit, setValue } = useFormContext<StyleGuideFormValues>();

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-6">
      <p className="text-sm text-gray-500">
        Override style guide sections for your organisation. Leave empty to use the default.
      </p>

      {STYLE_GUIDE_SECTIONS.map(section => (
        <div key={section.key} className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor={section.key}>{section.label}</Label>
            <button
              type="button"
              className="text-xs text-gray-400 hover:text-gray-600"
              onClick={() => setValue(section.key, "")}
            >
              Reset to default
            </button>
          </div>
          <textarea
            id={section.key}
            {...register(section.key)}
            rows={section.rows}
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder={section.placeholder}
          />
        </div>
      ))}

      <div className="flex justify-end gap-3 border-t pt-6">
        <Button type="button" variant="outline" onClick={onCancel} disabled={isUpdating}>
          Cancel
        </Button>
        <Button type="submit" disabled={isUpdating}>
          {isUpdating ? "Saving..." : "Save Style Guide"}
        </Button>
      </div>
    </form>
  );
};
